jQuery(function () {
    var formChanges = false;
    var form = $('.garden-spot-edit, .plant-edit');
    var mapForm = $('.js-map-edit');
    if (!(form.length > 0 || mapForm.length > 0)) {
        return;
    }
    if (mapForm.length > 0) {
        formChanges = true;
    }
    $(form).one('change', function () {
        formChanges = true;
    });
    $('.js-garden-check-changes-btn').on('click', function (e) {
        if (formChanges) {
            e.preventDefault();
            $('#garden-cancel-popup').closest('.popup-overlay').addClass('visible');
        }
        else {
            return;
        }
    });
    $('.js-garden-remove-btn').on('click', function () {
        $('#garden-remove-popup').closest('.popup-overlay').addClass('visible');
    });
});
